import { FunctionComponent } from 'react';

import { Card, Props } from './Card';
import { CardHeader } from './CardHeader';
import { CardBody } from './CardBody';
import { CardFooter } from './CardFooter';

interface ICard extends FunctionComponent<Props> {
  Header: typeof CardHeader;
  Body: typeof CardBody;
  Footer: typeof CardFooter;
}

const CardComponent: ICard = Card as ICard;
CardComponent.Header = CardHeader;
CardComponent.Body = CardBody;
CardComponent.Footer = CardFooter;

export { Card, CardHeader, CardBody, CardFooter };
export default CardComponent;
